import { render, staticRenderFns } from "./EventTypeStatistics.vue?vue&type=template&id=4ad90462&scoped=true&"
import script from "./EventTypeStatistics.vue?vue&type=script&lang=js&"
export * from "./EventTypeStatistics.vue?vue&type=script&lang=js&"
import style0 from "./EventTypeStatistics.vue?vue&type=style&index=0&id=4ad90462&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad90462",
  null
  
)

export default component.exports